jQuery(document).ready(function ($) {
    $('.site-header__toggle').on('click keydown', function (event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
            return;
        }
        if (event.type === 'keydown') {
            event.preventDefault();
        }

        $(this).toggleClass('active');
        $('.site-menu').toggleClass('active');
        $('.site-menu__toggle').toggleClass('active');
    });

    $('.site-menu__toggle').on('click keydown', function (event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
            return;
        }
        if (event.type === 'keydown') {
            event.preventDefault();
        }

        $(this).toggleClass('active');
        $('.site-menu').toggleClass('active');
        $('.site-header__toggle').toggleClass('active');
    });

    $('.site-menu__item--toggle').on('click keydown', function (event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
            return;
        }
        if (event.type === 'keydown') {
            event.preventDefault();
        }

        $(this).toggleClass('open');
        $(this).parent().next().slideToggle(500);
    });

    // Close the menu if a click occurs outside of it and the menu is active.
    $(document).on('click', function (event) {
        if (!$('.site-menu').hasClass('active')) return;
        // If the click is on the hamburger toggle button or a sub-menu toggle, do nothing.
        if ($(event.target).closest('.site-header__toggle, .site-menu__item--toggle').length) return;
        
        // If the click is on the site menu container (but not a link), do nothing.
        if ($(event.target).closest('.site-menu').length && !$(event.target).closest('a').length) return;

        $('.site-menu').removeClass('active');
        $('.site-header__toggle').removeClass('active');
        $('.site-menu__toggle').removeClass('active');
    });

    function applyScrollClassToHeader(event = null) {
        const scroll_position = $(this).scrollTop();

        if (scroll_position > 100) {
            $('.site-header')
                .addClass('scroll')
                .prev()
                .addClass('scroll');

            //$('.site-header__logo.home').fadeIn(250);
        }
        else {
            $('.site-header')
                .removeClass('scroll')
                .prev()
                .removeClass('scroll');

            //$('.site-header__logo.home').fadeOut(250);
        }
    }

    $(document).on('scroll', function (event) {
        applyScrollClassToHeader(event);
    });

    applyScrollClassToHeader();
});